// extracted by mini-css-extract-plugin
export default {"skip-checkbox":"skip-checkbox_XMXSL0mN"};